module.exports = __webpack_public_path__ + "d3a5d64a8534322988a4bed1b7dbc8b0.png";